import { render, staticRenderFns } from "./tableNft.vue?vue&type=template&id=cf8b86d8&"
import script from "./tableNft.vue?vue&type=script&lang=js&"
export * from "./tableNft.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./tableNft.vue?vue&type=style&index=1&id=cf8b86d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports